import React from 'react';
import './search-results-row.css';

const SearchResultsRow = props => {
  const setActive = e => {
    e.preventDefault();
    props.setActiveGuitar(props.guitar);
  };

  return (
    <tr className="results-row" onClick={setActive}>
      <td>
        <img src={`${props.guitar.photo}`} alt="Guitar" height="60" />
      </td>
      <td>{props.guitar.title}</td>
      <td>${props.guitar.price}</td>
    </tr>
  );
};

export default SearchResultsRow;



// WEBPACK FOOTER //
// ./src/search-results/search-results-row.js